import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SeatConfigData {
  rows: number;
  columns: number;
}

@Component({
  selector: 'app-create-seats',
  templateUrl: './create-seats.component.html',
  styleUrls: ['./create-seats.component.scss']
})
export class CreateSeatsComponent {
  constructor(
    public dialogRef: MatDialogRef<CreateSeatsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SeatConfigData
  ) {
    // Valores por defecto
    if (!this.data.rows) this.data.rows = 15;
    if (!this.data.columns) this.data.columns = 12;
  }

  getTotalSeats(): number {
    return (this.data.rows || 0) * (this.data.columns || 0);
  }

  isValid(): boolean {
    return this.data.rows > 0 &&
      this.data.columns > 0 &&
      this.data.rows <= 50 &&
      this.data.columns <= 50;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onCreate(): void {
    if (this.isValid()) {
      this.dialogRef.close({
        rows: this.data.rows,
        columns: this.data.columns,
        confirmed: true
      });
    }
  }
}
